import { Component, Input, OnInit } from '@angular/core';
import * as fromShared from '../../../shared';
import * as fromInvoiceSetup from '../../../data-services/invoice/setup';
import { ReplaySubject } from 'rxjs';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-selections',
    templateUrl: './invoice-selections.component.html',
    styleUrls: ['./invoice-selections.component.scss'],
    standalone: false
})
export class InvoiceSelectionsComponent
    extends fromShared.EditGrid<fromInvoiceSetup.Selections.InvoiceSelections>
    implements OnInit {
    numCols = 6;
    addSelectionReplaySubject = new ReplaySubject<boolean>(1);
    editItemSubject =
        new ReplaySubject<fromInvoiceSetup.Selections.InvoiceSelections>(1);
    @Input() invoiceProperties: SelectItem[] = [];
    constructor(private log: LoggingService) {
        super();
    }

    ngOnInit(): void {}
    onEditItem(item: fromInvoiceSetup.Selections.InvoiceSelections) {
        this.log.verbose({
            type: 'InvoiceSelectionsComponent:onEditItem',
            item
        });
        this.editItemSubject.next(item);
        this.addSelectionReplaySubject.next(true);
    }
    onSaveSelection($event) {
        this.SaveItem.next([$event]);
        this.addSelectionReplaySubject.next(false);
        this.editItemSubject.next({
            id: -1,
            Invoicepropertysharedid: -1
        } as fromInvoiceSetup.Selections.InvoiceSelections);
    }
    onCancelSelectionAdd() {
        this.addSelectionReplaySubject.next(false);
        this.editItemSubject.next({
            id: -1,
            Invoicepropertysharedid: -1
        } as fromInvoiceSetup.Selections.InvoiceSelections);
    }
}
